import type { Experience } from '../../../../types/CoreShoppingExperience';

interface Query {
  variantEncryptedId?: string;
}

const findFallBackProduct = (experience: Experience | undefined, query: Query) =>
  experience?.purchasableTrips
    .flatMap((t) => t.steps.flatMap((s) => s.products))
    .find((p) => p.fallbackVariants?.some((v) => v.encryptedId === query?.variantEncryptedId));

export default findFallBackProduct;
